import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { Container, Row, Column, List, Alert } from '@pella/sash-framework';
import { CTA } from '../../';
import { useNearestLocation } from '../../../hooks/use-nearest-location';

import EmailSignup from '../../common/email-signup';

const Footer = ({ hideTopFooter }) => {
	const staticData = useStaticQuery(query).contentstackFooter;
	const { store, status } = useNearestLocation();

	return (
		<footer className='palFooter mt-8 border-t-[10px] border-t-secondary xl:mt-12'>
			{!hideTopFooter && staticData?.upper_footer?.leadgen?.[0] && (
				<div className='palFooter-leadGen bg-gray-5 py-2.5 sm:py-5'>
					<Container width={1920}>
						<Row align='center'>
							{staticData.upper_footer.leadgen.map((col, index) => (
								<Column
									key={index}
									xs={12}
									md={6}
									className={`text-center ${index === 1 ? 'mt-5 border-t border-t-black pt-5 md:mt-0 md:border-l md:border-t-0 md:border-l-black md:!pl-12 md:pt-0' : 'md:!pr-12'}`}
								>
									{col.heading && <p className='mb-1 text-3xl font-semibold leading-tight'>{col.heading}</p>}
									{col.subheading && <p className='palFooterTop-Subheading mb-4 mt-0'>{col.subheading}</p>}
									{col.cta?.[0] && (
										<CTA
											data={col.cta[0]}
											className='mt-4'
										/>
									)}
									{index == 0 && <EmailSignup />}
								</Column>
							))}
						</Row>
					</Container>
				</div>
			)}

			<div className='palFooterBottom py-8 lg:py-12'>
				<Container>
					{staticData?.footer?.[0] && (
						<Row>
							{staticData.footer.map((col, index) => (
								<Column
									key={index}
									xs={12}
									md={4}
									xl={index === 0 ? 2 : index === 1 || index === 2 ? 3 : 4}
									className='mb-8 lg:mb-0'
								>
									{col.heading && <p className='mb-2.5 font-semibold uppercase tracking-3px md:mb-5'>{col.heading}</p>}

									{col.cta?.[0] && (
										<List bullets='none'>
											{col.cta.map((item, index) => (
												<li
													key={index}
													className='my-1'
												>
													<CTA
														data={item}
														className='text-inherit decoration-transparent hover:decoration-current'
													/>
												</li>
											))}
										</List>
									)}

									{status !== 'loading' && index == 3 && (
										<div>
											{status === 'success' && (
												<>
													{store.address && <p className='m-0'>{store.address}</p>}
													{store.address2 ? <p className='m-0'>{store.address2}</p> : ''}
													<p className='m-0'>
														{store.city}, {store.state} {store.postalCode}
													</p>
												</>
											)}
											{status === 'error' && (
												<Alert
													type='error'
													hideClose={true}
												>
													{store.error}
												</Alert>
											)}
										</div>
									)}
								</Column>
							))}
						</Row>
					)}
				</Container>
			</div>

			<div className='pal-copyright pb-6 text-center lg:pb-12'>
				<Container width={1225}>
					{staticData?.global_legal?.[0] && (
						<List
							bullets='none'
							layout='inline'
							className='justify-center'
						>
							{staticData.global_legal.map((link, index) => (
								<li
									key={index}
									className='mx-2.5 my-1 text-xs md:my-0'
								>
									<CTA
										data={link}
										className='text-inherit'
									/>
								</li>
							))}
						</List>
					)}

					<div className='text-center'>
						<span className='mr-1 text-xs'>&#169; {new Date().getFullYear()}</span>
						<span
							className='mx-0.5 text-xs'
							dangerouslySetInnerHTML={{ __html: staticData?.copyright }}
						/>
					</div>
				</Container>
			</div>
		</footer>
	);
};

Footer.propTypes = {
	hideTopFooter: PropTypes.bool,
};

export default Footer;

export const query = graphql`
	{
		contentstackFooter(uid: { eq: "bltce8c6280744bf132" }) {
			upper_footer {
				leadgen {
					heading
					subheading
					cta {
						...CTA
					}
				}
			}
			footer {
				heading
				cta {
					...CTA
				}
			}
			global_legal {
				...CTA
			}
			copyright
		}
	}
`;
